import React, {Component} from 'react';
import {Card, Breadcrumb} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import localDB from "../../data/localDB";
import CardDash from "../../components/extras/CardDash";

class ContactsDash extends Component {
    constructor() {
        super();
        this.state = {
            cards: []
        };
    }

    componentDidMount() {
        this.itemsMenu();
    }

    itemsMenu() {
        let menu = localDB.get('menu');
        let cards = menu.filter(menu => menu.type === 'contacts').map(item => {
            return <CardDash {...item} key={item.url}/>
        });
        this.setState({cards});
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Contactos - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section active>Contactos</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Card.Group stackable centered>
                    {this.state.cards}
                </Card.Group>
            </div>
        );
    }
}

export default ContactsDash;



// WEBPACK FOOTER //
// ./src/containers/contacts/ContactsDash.js